import React from 'react';
import styles from './AnimatedVisuals.module.css';

const AnimatedCode = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.codeHeader}>
        <div className={styles.codeDots}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
        <span className={styles.codeTitle}>solution.js</span>
      </div>
      <div className={styles.codeContent}>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>1</span>
          <span className={styles.code}><span className={styles.keyword}>const</span> <span className={styles.variable}>innovation</span> = <span className={styles.string}>'unlimited'</span>;</span>
        </div>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>2</span>
          <span className={styles.code}><span className={styles.keyword}>let</span> <span className={styles.variable}>success</span> = <span className={styles.function}>build</span>(<span className={styles.variable}>innovation</span>);</span>
        </div>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>3</span>
          <span className={styles.code}><span className={styles.keyword}>while</span> (<span className={styles.variable}>success</span>) {'{'}</span>
        </div>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>4</span>
          <span className={styles.code}>  <span className={styles.function}>transform</span>(<span className={styles.string}>'your business'</span>);</span>
        </div>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>5</span>
          <span className={styles.code}>  <span className={styles.comment}>{'// Zero downtime guaranteed'}</span></span>
        </div>
        <div className={styles.codeLine}>
          <span className={styles.lineNumber}>6</span>
          <span className={styles.code}>{'}'}</span>
        </div>
        <div className={styles.cursor}></div>
      </div>
    </div>
  );
};

export default AnimatedCode;

